import { render, staticRenderFns } from "./DynamicWidget.vue?vue&type=template&id=51315fd4&scoped=true&"
import script from "./DynamicWidget.vue?vue&type=script&lang=js&"
export * from "./DynamicWidget.vue?vue&type=script&lang=js&"
import style0 from "./DynamicWidget.vue?vue&type=style&index=0&id=51315fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51315fd4",
  null
  
)

export default component.exports